/* src/app/private/components/whatsapp-config/create-whatsapp-config/create-whatsapp-config.component.scss */
/*# sourceMappingURL=create-whatsapp-config.component.css.map */
